import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
  'calendar.month-switcher.today': {
    id: 'calendar.month-switcher.today',
    defaultMessage: 'Today',
    description: 'Label for the button to go to the current month in the calendar',
  },
  'calendar.month-switcher.previous': {
    id: 'calendar.month-switcher.previous',
    defaultMessage: 'Previous',
    description: 'Label for the button to go to the previous month in the calendar',
  },
  'calendar.month-switcher.next': {
    id: 'calendar.month-switcher.next',
    defaultMessage: 'Next',
    description: 'Label for the button to go to the next month in the calendar',
  },
  'add-entry-button.label': {
    id: 'add-entry-button.label',
    defaultMessage: 'Create entry',
    description: 'The label text for the add entry button.',
  },
});
